import { Controller } from 'stimulus';

class PaymentController extends Controller {
  connect() {
    this.sendGtmPaymentMethod();
  }

  onPaymentChange() {
    this.sendGtmPaymentMethod();
  }

  getSelectedPaymentMethod() {
    const checked = this.checkboxTargets.filter(checkboxElement => checkboxElement.checked);

    return checked.length ? checked[0] : null;
  }

  sendGtmPaymentMethod() {
    const data = JSON.parse(this.element.dataset.gtmEcommerce);
    const selectedPaymentMethod = this.getSelectedPaymentMethod();

    if (selectedPaymentMethod && typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: 'addPaymentInfo',
        ...data,
        payment_type: selectedPaymentMethod.dataset.title,
      });
    }
  }
}

PaymentController.targets = [
  'checkbox',
];

export default PaymentController;
